module.exports = __webpack_public_path__ + "img/1.2ce1e903.png";